import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  CircularProgress,
  useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const CATEGORIES = [
  { value: 'inaccurate', label: 'No es preciso / factualmente incorrecto' },
  { value: 'not_following_instructions', label: 'No siguio instrucciones' },
  { value: 'not_helpful', label: 'No es util' },
  { value: 'incomplete', label: 'Respuesta incompleta' },
  { value: 'bad_style', label: 'Estilo inadecuado' },
  { value: 'other', label: 'Otro' },
];

const FeedbackDialog = ({ open, onClose, onSubmit, isSubmitting }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 599px)');
  const [category, setCategory] = useState('');
  const [comment, setComment] = useState('');

  const handleClose = () => {
    setCategory('');
    setComment('');
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({ category: category || null, comment: comment || null });
    setCategory('');
    setComment('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth fullScreen={isMobile}>
      <DialogTitle>Danos tu opinion</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="feedback-category-label">{t('feedback.categoryLabel')}</InputLabel>
            <Select
              labelId="feedback-category-label"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              label={t('feedback.categoryLabel')}
            >
              <MenuItem value="">
                <em>Ninguna</em>
              </MenuItem>
              {CATEGORIES.map(cat => (
                <MenuItem key={cat.value} value={cat.value}>{cat.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            multiline
            rows={3}
            fullWidth
            size="small"
            label={t('feedback.commentLabel')}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>{t('common.cancel')}</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} /> : null}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog;
